import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams, useLocation, Link } from 'react-router-dom';
// import { LeftSideSection } from "./LeftSideSection";
import { RightSideSection } from './RightSideSection';
import { usePurchaseOrderState } from '../PurchaseOrderContext';
import Loader from '../../../../Components/Utility/Loader/Loader';
import PurchaseOrderDocuments from '../PurchaseOrderDocuments/PurchaseOrderDocuments';
import * as action from '../Store/PurchaseOrder.action';
import CustomConfirmationPopup from '../../../../Components/ModalPopup/CustomConfirmationPopup';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../../../UserSetting/UsersLibrary/UserRights';

function PurchaseOrderDetails() {
  const {
    BOMConfigDetails: { productDetails },
    purchaseOrderData: { devorderData },
    UserDetails: { isSupplierLoggedIn },
  } = useSelector((reduxState) => reduxState);
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const cancelPurchaseOrder = t('FILTER.CANCEL_PURCHASE');
  const cancelRequest = t('FILTER.CANCE_REQUEST');
  const { devOrderId, poCreatedId } = useParams();
  const history = useHistory();
  const location = useLocation();

  const isPreviewMode = 'true';
  const {
    purchaseOrderState: { loader, status, poOrderNo, supplierId },
    controlState: {
      poFilesModalState,
      confirmModalType,
      confirmModalState,
      confirmModalMessage,
      confirmModalSecondMessage,
      confirmModalThirdMessage,
      confirmModalShowthirdMsg,
      confirmModalTitle,
      confirmModalCommentState,
      confirmModalCommentMsg,
      confirmModalLoading,
    },
    setControlState,
    purchaseOrderState,
    setPurchaseOrderState,
    initialSetting,
    callDevorderApiFn,
    callDevorderPoidApiFn,
    callUserIdBasedApiFn,
    isProductArchived,
    oldInitialSetting,
    setOldState,
    fromPreview,
  } = usePurchaseOrderState();

  if (localStorage.getItem('redirectionToPO')) {
    localStorage.removeItem('redirectionToPO');
  }

  const [cancleReq, setCancleReq] = useState(false);
  const [forRedirection, setForReDirection] = useState(false);
  const ProductTestingData = useSelector((redState) => redState);
  const { Users } = ProductTestingData;
  const { logInRights } = Users;

  const { CheckActionPermission } = useComponent();
  const POAddEditAccess = CheckActionPermission(logInRights, 'products', 'purchaseOrder', 'addEdit');
  const approveRejectAccess = CheckActionPermission(logInRights, 'products', 'purchaseOrder', 'approveReject');
  const PODeleteAccess = CheckActionPermission(logInRights, 'products', 'purchaseOrder', 'delete');

  const searchParams = new URLSearchParams(location?.search);
  const locaStates = location?.state;
  const listView = searchParams.get('list');
  const list = locaStates?.list ?? Boolean(listView);
  const stateDuplication = searchParams.get('forDuplication');
  const forDuplication = locaStates?.forDuplication || Boolean(stateDuplication);

  useEffect(() => {
    if (list) {
      setForReDirection(true);
    }
  }, [list]);

  useEffect(() => {
    if (devOrderId && poCreatedId) {
      const obj = {
        devOrderId,
        poId: poCreatedId,
        poOrderId: poCreatedId,
      };
      dispatch(action.fethcPoDetails(obj));
    }
  }, [devOrderId, poCreatedId, dispatch]);

  const toggleFiles = () => {
    setControlState((poStateEnd) => ({
      ...poStateEnd,
      poFilesModalState: false,
    }));
  };

  const handleFiles = async () => {
    setControlState((poState) => ({
      ...poState,
      poFilesModalState: true,
    }));
    await dispatch(action.fetchPODocs({ devOrderId }, poCreatedId));
  };

  const redirectPurchaseOrderListPage = () => {
    history.push(`/development-order/${devOrderId}/product-purchase-orders`);

    setOldState((...oldStates) => ({
      ...oldStates,
      ...oldInitialSetting,
    }));
  };

  const redirectToTODO = () => {
    history.push('/todo-list/purchase-order');
    // checking to reset to oldSetting
    setOldState((...oldStates) => ({
      ...oldStates,
      ...oldInitialSetting,
    }));
  };

  const handleConfirmModal = () => {
    history.push(`/development-order/${devOrderId}/product-purchase-order`);
  };

  const handleToggle = () => {
    setControlState((poStateEnd) => ({
      ...poStateEnd,
      confirmModalType: '',
      confirmModalState: false,
      confirmModalMessage: '',
      confirmModalSecondMessage: '',
      confirmModalThirdMessage: '',
      confirmModalShowthirdMsg: false,
      confirmModalTitle: '',
      confirmModalCommentState: false,
      confirmModalCommentMsg: '',
      confirmModalLoading: false,
    }));
  };

  const onConfirm = async () => {
    switch (confirmModalType) {
      case 'back':
        await dispatch(action.emptyData());
        redirectPurchaseOrderListPage();
        break;
      case 'revise':
      case 'cancel': {
        setControlState((poStateEnd) => ({
          ...poStateEnd,
          confirmModalLoading: true,
        }));
        const obj = {
          devOrderId,
          poId: poCreatedId,
        };
        const reqObj = {
          comment: null,
          poOrderNo,
          status: confirmModalType === 'cancel' ? 'canceled' : 'revised',
          supplierId,
        };
        const res = await dispatch(action.revisePo(obj, reqObj));
        if (res) {
          setPurchaseOrderState((prevState) => ({
            ...prevState,
            status: reqObj.status,
          }));
          handleToggle();
          await callDevorderApiFn();
          await callDevorderPoidApiFn();
          await callUserIdBasedApiFn();
        }
        break;
      }
      case 'Reject':
      case 'Approve':
      case 'ApproveAfterCancle': {
        setPurchaseOrderState((prevState) => ({
          ...prevState,
          ...initialSetting,
        }));
        setControlState((poStateEnd) => ({
          ...poStateEnd,
          confirmModalLoading: true,
        }));
        const data = {
          devOrderId,
          createPoId: poCreatedId,
          status: confirmModalType === 'ApproveAfterCancle' ? 'Approve' : confirmModalType,
          comment: confirmModalCommentMsg,
          supplierId,
          PoNo: poOrderNo,
          devOrderDetails: {
            brand: devorderData?.brandId,
            catOne: devorderData?.catOneId,
            catTwo: devorderData?.catTwoId,
          },
        };
        const response = await dispatch(action.rejectApprove(data, t));
        if (response) {
          handleToggle();
          await callDevorderApiFn();
          await callDevorderPoidApiFn();
          await callUserIdBasedApiFn();
        }
        break;
      }
      case 'RejectAfterCancle': {
        setPurchaseOrderState((prevState) => ({
          ...prevState,
          ...initialSetting,
        }));
        setControlState((poStateEnd) => ({
          ...poStateEnd,
          confirmModalLoading: true,
        }));
        const object = {
          devOrderId,
          createPoId: poCreatedId,
          status: 'canceled',
          comment: confirmModalCommentMsg,
          supplierId,
          PoNo: poOrderNo,
          devOrderDetails: {
            brand: devorderData?.brandId,
            catOne: devorderData?.catOneId,
            catTwo: devorderData?.catTwoId,
          },
        };
        const results = await dispatch(action.rejectApprove(object, t));
        if (results) {
          handleToggle();
          await callDevorderApiFn();
          await callDevorderPoidApiFn();
          await callUserIdBasedApiFn();
        }
        break;
      }
      default:
        break;
    }
  };

  useEffect(() => {
    return () => {
      setPurchaseOrderState((prevState) => ({
        ...prevState,
        ...initialSetting,
      }));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCancleRequest = async () => {
    const params = {
      comment: null,
      poOrderNo: purchaseOrderState.poOrderNo,
      status: cancelRequest,
      supplierId,
    };
    const res = await dispatch(action.changingStatus(purchaseOrderState._id, devOrderId, params, t));
    if (res) {
      setCancleReq(false);
      await callDevorderApiFn();
      await callDevorderPoidApiFn();
      await callUserIdBasedApiFn();
    }
  };

  const conformCancleReq = () => {
    setCancleReq(true);
  };

  const isStatusConfirmedOrRejected =
    status === t('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.STATUS_LABELS.CONFIRMED') ||
    status === t('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.STATUS_LABELS.REJECTED');

  const finalRender =
    confirmModalTitle === t('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.MODAL_TITLES.REJECT_PURCHASE_ORDER')
      ? t('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.MODAL_ACTIONS.REJECT_AND_SEND')
      : t('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.MODAL_ACTIONS.APPROVE_AND_SEND');

  return (
    <>
      <div>
        <div className="page-title-filter sticky">
          <div className="title-container">
            <h4 className="title">
              {t('ADD_PO_TEMPLATE_PROVIDER.CREATE_PO')} | {productDetails?.number}
            </h4>
          </div>
          <div className="search-filter">
            {!isPreviewMode &&
              status === t('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.STATUS_LABELS.ACTIVE') &&
              approveRejectAccess &&
              !forDuplication &&
              POAddEditAccess && (
                <>
                  <button className="btn btn-po btn-red" type="button" onClick={() => handleConfirmModal()}>
                    {t('FILTER.REJECT_PO')}
                  </button>
                  <button className="btn btn-po btn-green" type="button" onClick={() => handleConfirmModal()}>
                    {t('FILTER.CONFIRM_PO')}
                  </button>
                </>
              )}
            {!isPreviewMode && status === cancelRequest && !isSupplierLoggedIn && !forDuplication && POAddEditAccess && (
              <>
                <button className="btn btn-po btn-red" type="button" onClick={() => handleConfirmModal()}>
                  {t('FILTER.REJECT_CANCEL')}
                </button>
                <button className="btn btn-po btn-green" type="button" onClick={() => handleConfirmModal()}>
                  {t('FILTER.CONFIRM_CANCEL')}
                </button>
              </>
            )}
            {!isPreviewMode && !forDuplication && POAddEditAccess && (
              <button className="btn btn-white btn-back-lib" type="button" onClick={handleFiles} disabled={isProductArchived}>
                {t('PURCHASE_ORDER_NUMBER.FILES')}
              </button>
            )}
            {!isPreviewMode &&
              ((!isSupplierLoggedIn && !forDuplication && POAddEditAccess) ||
                (isProductArchived && (
                  <>
                    <Link
                      className="cursor-pointer text-dark text-decoration-none btn btn-white btn-back-lib"
                      to={`/development-order/${devOrderId}/order-po-history/${poCreatedId}?list=forRedirection`}
                    >
                      {t('FILTER.PO_HISTORY')}
                    </Link>
                    <Link
                      className="cursor-pointer text-dark text-decoration-none btn btn-white btn-back-lib"
                      to={`/development-order/${devOrderId}/order-po-log/${poCreatedId}?list=forRedirection`}
                    >
                      {t('FILTER.PO_LOG')}
                    </Link>
                  </>
                )))}
            <button className="btn btn-white btn-back-lib" type="button" onClick={() => handleConfirmModal()} disabled={isProductArchived}>
              <i className="icon-back" />
              {t('FILTER.BACK')}
            </button>

            {!isPreviewMode &&
              status === t('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.STATUS_LABELS.ACTIVE') &&
              !isSupplierLoggedIn &&
              POAddEditAccess &&
              !forDuplication && (
                <>
                  <button className="btn btn-white btn-back-lib" type="button" onClick={() => handleConfirmModal()}>
                    {t('FILTER.REVISE_PO')}
                  </button>
                  <button className="btn btn-white btn-back-lib" type="button" onClick={() => handleConfirmModal()}>
                    {t('FILTER.CANCEL_PO')}
                  </button>
                </>
              )}

            {!isPreviewMode &&
              status === t('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.STATUS_LABELS.REJECTED') &&
              !isSupplierLoggedIn &&
              !forDuplication &&
              POAddEditAccess && (
                <>
                  <button className="btn btn-white btn-back-lib" type="button" onClick={() => handleConfirmModal()}>
                    {t('FILTER.REVISE_PO')}
                  </button>
                  <button className="btn btn-white btn-back-lib" type="button" onClick={() => handleConfirmModal()}>
                    {t('FILTER.CANCEL_PO')}
                  </button>
                </>
              )}
            {!isPreviewMode && status === cancelRequest && !isSupplierLoggedIn && !forDuplication && POAddEditAccess && (
              <button className="btn btn-white btn-back-lib" type="button" onClick={() => handleConfirmModal()}>
                {t('FILTER.REVISE_POS')}
              </button>
            )}
            {!isPreviewMode && isStatusConfirmedOrRejected && !isSupplierLoggedIn && !forDuplication && POAddEditAccess && (
              <button className="btn btn-white p-2 ml-1" type="button" onClick={conformCancleReq}>
                {t('FILTER.CANCE_REQUEST')}
              </button>
            )}
          </div>
        </div>
        {loader && <Loader />}
        {!loader &&
          (isProductArchived ? (
            <div className="d-flex align-items-center justify-content-center">{t('FILTER.MESSAGE_PO')} </div>
          ) : (
            <Container fluid>
              <Row>
                <Col lg={isSupplierLoggedIn || isPreviewMode ? 12 : 10} style={{ maxHeight: 'calc(100vh - 180px)', overflow: 'auto' }}>
                  <RightSideSection />
                </Col>
              </Row>
            </Container>
          ))}
      </div>
      {cancleReq && (
        <ConfirmationPopup
          onOpen={cancleReq}
          title={t('FILTER.CANCEL_PURCHASE_MESSAGE')}
          message={t('FILTER.ARE_U_SURE_DELETE_MESSAGE')}
          onConfirm={handleCancleRequest}
          toggle={() => setCancleReq(false)}
        />
      )}
      {poFilesModalState && (
        <PurchaseOrderDocuments
          onOpen={poFilesModalState}
          toggle={toggleFiles}
          data={{ _id: poCreatedId, list }}
          POAddEditAccess={POAddEditAccess}
          PODeleteAccess={PODeleteAccess}
        />
      )}
      {confirmModalState &&
      (confirmModalTitle === t('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.MODAL_TITLES.REJECT_PURCHASE_ORDER') ||
        confirmModalTitle === cancelPurchaseOrder ||
        confirmModalTitle === t('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.MODAL_TITLES.APPROVE_PURCHASE_ORDER')) ? (
        <CustomConfirmationPopup
          onOpen={confirmModalState}
          onConfirm={onConfirm}
          title={confirmModalTitle}
          message={confirmModalMessage}
          toggle={handleToggle}
          loading={confirmModalLoading}
          secondMessage={confirmModalSecondMessage}
          showThirdMsg={confirmModalShowthirdMsg}
          thirdMessage={confirmModalThirdMessage}
          commentText={(e) =>
            setControlState((prevState) => ({
              ...prevState,
              confirmModalCommentMsg: e.target.value,
            }))
          }
          isCommentOn={confirmModalCommentState}
          customClass="modal-medium"
          customCommentLabel={t('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.MODAL_ACTIONS.COMMENTS')}
          customSuccessBtn={confirmModalTitle === cancelPurchaseOrder ? t('PURCHASE_ORDER.PRODUCT_PURCHASE_ORDER.MODAL_ACTIONS.CANCEL_AND_SEND') : finalRender}
          customFailureBtn={t('COMMON_LABEL.CANCEL')}
          disabledBtn={confirmModalLoading}
        />
      ) : (
        <ConfirmationPopup
          onOpen={confirmModalState}
          onConfirm={onConfirm}
          loading={confirmModalLoading}
          title={confirmModalTitle}
          message={confirmModalMessage}
          toggle={handleToggle}
          secondMessage={confirmModalSecondMessage}
          showThirdMsg={confirmModalShowthirdMsg}
          thirdMessage={confirmModalThirdMessage}
          commentText={(e) =>
            setControlState((prevState) => ({
              ...prevState,
              confirmModalCommentMsg: e.target.value,
            }))
          }
          isCommentOn={confirmModalCommentState}
        />
      )}
    </>
  );
}

export default PurchaseOrderDetails;
